import {fetchLiveDataForStaleEvaluation} from 'notebook/structured-tables/live-data/fetchStructuredTableLiveData';
import {QueryResolution} from 'notebook/tables/TableStoreTransforms';

export default async function fetchLiveDataOnEntryMount(
  queryResolutions: Array<QueryResolution>
): Promise<void> {
  const evaluatedCellResolutionQueries = queryResolutions.map((queryResolution) => queryResolution.query);

  // TODO(BNCH-32522): Set fetching for LUC up to be recurring instead of only on mount.
  await fetchLiveDataForStaleEvaluation(evaluatedCellResolutionQueries);
}
